export { default } from './RedactorText';
